export const HASURA_NAMES = {
  org_3R60rCG9HWYwPpC0: 'dev-folio-db',
  org_uajc8Wr0rLFlqXz8: 'uat',
  org_kUN3WbpsHzp0hbX6: 'artis-staging',
  org_XYwWBaz6vrPdxjeW: 'prod-folio-tpicap',
} as const;

export function getHasuraName(orgId: keyof typeof HASURA_NAMES) {
  const name = HASURA_NAMES[orgId];
  if (name) {
    return name;
  } else {
    throw new Error(`No Hasura name found for Org ID: ${orgId}`);
  }
}

export const isDev = import.meta.env.DEV;

// Auth0 Configuration
export type TEnv = 'dev' | 'uat' | 'prod';

export const AUTH0_DOMAINS = {
  dev: 'https://artisworksdev.eu.auth0.com',
  uat: 'https://artisworks.eu.auth0.com',
  prod: 'https://artisfoliostaging.eu.auth0.com',
} as const;

export const AUTH0_CLIENT_IDS = {
  dev: 'e7bR2BuJBNFRacmoWWEnWsd2RJnusOeC',
  uat: 'Ign674yw9bRUQpa7rzPkoeGlV4xQOq75',
  prod: 'sAnIHmSmBu7SwYlewnAGBKhsHv5lFi1o',
} as const;

export function getEnvironment(hostname: string): TEnv {
  if (hostname.includes('main') || hostname.includes('staging')) {
    return 'uat';
  } else if (hostname.includes('prod') || hostname.includes('artis.works') || hostname === 'excel.artis.works') {
    return 'prod';
  }
  return 'dev';
}

// Cloudflare Worker (partykit-relay/) that relays the login token to the add-in.
// Also hardcoded in netlify.toml's /astp/* redirect - keep both in sync.
export const PARTYKIT_HOST = 'astp-relay.artis-excel.workers.dev';
